export const MINIMUM_MESSAGE: string = 'Value less than minimum value';
export const MAXIMUM_MESSAGE: string = 'Value greater than maximum value';
export const EMAIL_MESSAGE: string = 'Email is not valid';
export const NO_ONLY_SPACE_MESSAGE: string = 'This field is required';
export const AT_LEAST_8_CHAR_MESSAGE: string = 'Password must be at least 8 characters length';
export const INCLUDE_SPECIAL_CHAR_MESSAGE: string = 'Password must include special characters';
export const INCLUDE_UPPER_LOWER_CASE_CHAR_NUMBER_MESSAGE: string = `Password must combine uppercase letters, lowercase letters and numbers`;
export const SPECIAL_CHAR_MESSAGE: string = 'Password must only include special characters from !@#$%^&*()_+ and spaces are not allowed';
export const UUID_MESSAGE: string = 'is not a valid UUID format';

export const EMAIL_INPUT = {
  type:'email',
  controlName: 'Email',
}

export const TELEPHONE_INPUT ={
  type:'tel',
  controlName: 'PhoneNumber',
}

export const PASSWORD_INPUT = {
  type:'password',
  controlName: 'Password',
}
